import { idempotencyConfig } from "./idempotency";
export const getClubVisibleMembershipPlans = async (client, clubId, params = {}) => {
    const response = await client.get(`/membershipplans/club/${clubId}/visible`, { params });
    return response.data;
};
export const getMyMembershipRequests = async (client, params = {}) => {
    const response = await client.get("/membership-requests/my", { params });
    return response.data;
};
export const getOwnerMembershipRequests = async (client, params = {}) => {
    const response = await client.get("/membership-requests", { params });
    return response.data;
};
export const getMembershipRequestById = async (client, requestId) => {
    const response = await client.get(`/membership-requests/${requestId}`);
    return response.data;
};
export const submitMembershipRequest = async (client, body) => {
    const response = await client.post("/membership-requests", body);
    return response.data;
};
export const approveMembershipRequest = async (client, requestId, body, options) => {
    const url = `/membership-requests/${requestId}/approve`;
    const config = idempotencyConfig(options);
    const response = config
        ? await client.post(url, body, config)
        : await client.post(url, body);
    return response.data;
};
export const rejectMembershipRequest = async (client, requestId, body) => {
    const response = await client.post(`/membership-requests/${requestId}/reject`, body);
    return response.data;
};
export const cancelMembershipRequest = async (client, requestId) => {
    const response = await client.post(`/membership-requests/${requestId}/cancel`);
    return response.data;
};
